import React, { useState } from "react";
import { Modal, Button, Row, Col, Typography } from "antd";
import { UploadOutlined, EditOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const AddDocumentModal = ({
  open,
  onCancel,
  handleAddNewWithUpload,
  handleAddNewWithEditor,
  docTypeGroup
}) => {
  const [selectedType, setSelectedType] = useState(null); // 'upload' or 'editor'

  return (
    <Modal
      title="Add Document"
      open={open}
      onCancel={onCancel}
      className="add-document-modal"
      width={720}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button
          key="start"
          type="primary"
          onClick={() => {
            if (selectedType === "upload") {
              handleAddNewWithUpload();
            } else {
              handleAddNewWithEditor();
            }
            onCancel();
          }}
          disabled={!selectedType}
        >
          Start Setup
        </Button>,
      ]}
    >
      <Row gutter={32} justify="center">
        <Col>
          <div
            className={`text-button-container ${
              selectedType === "upload" ? "active" : ""
            }`}
            onClick={() => setSelectedType("upload")}
          >
            <UploadOutlined />
            <Title level={5}>Upload Document</Title>
            <Text>
              {docTypeGroup?.hasContent ? "Allows uploading an HTML that is compatible with Sourcepoint's builder." : "Allows linking the legal document file from your system in the message for version tracking (PDF, TXT, DOCX, JPG)"}
            </Text>
          </div>
        </Col>
        <Col>
          <div
            className={`text-button-container ${
              selectedType === "editor" ? "active" : ""
            }`}
            onClick={() => setSelectedType("editor")}
          >
            <EditOutlined />
            <Title level={5}>Enter Text Manually</Title>
            <Text>
              Allows displaying the legal document in the message. You can
              format the content of your message based on your requirements
            </Text>
          </div>
        </Col>
      </Row>
    </Modal>
  );
};

export default AddDocumentModal;
